// ============================================================================
// CHINESE (SIMPLIFIED) TRANSLATIONS - FUN QUESTIONS
// ============================================================================
// 关于信仰的反思性和有趣问题

export const funQuestions = [
  {
    question: "耶稣的哪个爱的行动最激励你的日常生活？",
    emoji: "❤️",
    theme: "爱"
  },
  {
    question: "如果你能与一位圣经人物共进晚餐，你会选谁，为什么？",
    emoji: "🍞",
    theme: "相遇"
  },
  {
    question: "耶稣的哪个比喻最深地触动你，为什么？",
    emoji: "🌱",
    theme: "教导"
  },
  {
    question: "神的平安如何在你的生活中显现？",
    emoji: "🕊️",
    theme: "平安"
  },
  {
    question: "你最想亲眼见证耶稣的哪个神迹？",
    emoji: "✨",
    theme: "信心"
  },
  {
    question: "如果用一个词来描述神的爱，你会选什么？",
    emoji: "💝",
    theme: "神圣之爱"
  },
  {
    question: "哪一节圣经经文在困难时刻帮助了你？",
    emoji: "📖",
    theme: "安慰"
  },
  {
    question: "今天你如何成为世上的光？",
    emoji: "💡",
    theme: "见证"
  }
];

export default funQuestions;
